const footerLinks = [
  { Link: "/blog", Title: "Articles" },
  { Link: "/interviews", Title: "Interviews" },
  { Link: "/collections", Title: "Collections" },
  { Link: "/books", Title: "Books" },
  { Link: "/courses", Title: "Courses" },
  { Link: "/workshops", Title: "Workshops" },
  { Link: "/testimonials", Title: "Testimonials" },
  { Link: "/about", Title: "About" },
]

export default footerLinks
